<template>
  <div id="pdf-tamplate-texts-table">
    <span style="font-size:24px;bold">{{$t('pdf_template_texts_table.texts')}}</span>
    <table cellpadding="0" cellspacing="0">
      <tr class="header-row" v-if="template.texts.length > 0">
        <td
          v-for="(header, i) in headers"
          :key="i"
          :style="{ 'width': header.width + '%'}"
        >{{header.text}}</td>
      </tr>
      <tr v-for="(text, i) in template.texts" :key="i">
        <td>
          <input v-model="text.x1" type="number" @keydown="joystick($event, text, ['x1', 'y1'])" />
        </td>
        <td>
          <input v-model="text.y1" type="number" @keydown="joystick($event, text, ['x1', 'y1'])" />
        </td>
        <td>
          <input
            v-model="text.width"
            type="number"
            @keydown="joystick($event, text, ['width', 'height'])"
          />
        </td>
        <td>
          <input
            v-model="text.height"
            type="number"
            @keydown="joystick($event, text, ['width', 'height'])"
          />
        </td>
        <td>
          <input v-model="text.font_size" type="number" />
        </td>
        <td>
          <select v-model="text.align" style="width:100%">
            <option selected value="L">L</option>
            <option value="C">C</option>
            <option value="R">R</option>
          </select>
        </td>
        <td>
          <input v-model="text.bold" type="checkbox" />
        </td>
        <td>
          <input v-model="text.italic" type="checkbox" />
        </td>
        <td>
          <input v-model="text.text" type="text" />
        </td>
        <td>
          <v-icon small @click="deleteText(i)">delete</v-icon>
        </td>
      </tr>
    </table>
    <button
      type="submit"
      class="btn btn-primary"
      @click="addText"
    >{{$t('pdf_template_texts_table.add_text')}}</button>
  </div>
</template>

<script>
import PdfTemplateText from "@/models/PdfTemplateText.js";
import Helper from "@/models/Helper.js";
export default {
  name: "pdf-template-texts-table",
  props: {
    template: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      headers: [
        {
          text: "X",
          width: 5,
        },
        {
          text: "Y",
          width: 5,
        },
        {
          text: this.$t("pdf_template_texts_table.width"),
          width: 5,
        },
        {
          text: this.$t("pdf_template_texts_table.height"),
          width: 5,
        },
        {
          text: this.$t("pdf_template_texts_table.font_size"),
          width: 5,
        },
        {
          text: this.$t("pdf_template_texts_table.alignment"),
          width: 5,
        },
        {
          text: this.$t("pdf_template_texts_table.bold"),
          width: 5,
        },
        {
          text: this.$t("pdf_template_texts_table.italic"),
          width: 5,
        },
        {
          text: this.$t("pdf_template_texts_table.text"),
          width: 55,
        },
        {
          text: this.$t("pdf_template_texts_table.actions"),
          with: 5,
        },
      ],
      defaultText: {
        x1: 0,
        y1: 0,
        width: 0,
        height: 0,
        font_size: 12,
        align: "L",
        bold: false,
        italic: false,
        text: "",
      },
    };
  },
  methods: {
    addText() {
      this.template.texts.push(new PdfTemplateText(this.defaultText));
    },
    deleteText(i) {
      this.template.texts.splice(i, 1);
    },
    joystick(e, box, props) {
      Helper.joystick(e, box, props);
    },
  },
};
</script>

<style scoped>
input {
  border: 0px solid #000;
  margin: 0;
  background: transparent;
  width: 100%;
}
table tr td {
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
}
table {
  background: #fff none repeat scroll 0 0;
  border-left: 1px solid #000;
  border-top: 1px solid #000;
}
table tr:nth-child(even) {
  background: #ccc;
}
table tr:nth-child(odd) {
  background: #eee;
}
.header-row {
  font-weight: bold;
}
</style>